import React from 'react'

import pill from "./../../../UI/general/pill.svg"
import asoleacion from "./../../../UI/asoleacion/modalIcon.svg"

interface Props {
  handleAsoleacionImagesCount: any,
  asoleacionCurrentSetCount: any,
  handleAsoleacionChangeIndex: any,
  isAsoleacionModalOpened: boolean,
  handleOpenAsoleacionModel: any,
  asolacionData: any,
  colorsData: any,
  handleChangeAsoleacionTime: any,
  asoleacionCurrentSetIndex: any,
  handleChangeAsoleacionSet: any,
  handleAutoplayAsoleacion: any,
  asoleacionCurrentSet: any
}

interface State {}

class AsoleacionUI extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isAsoleacionModalOpened ? "asoleacion-ui-mobile fade-in":"asoleacion-ui-mobile fade-out"}>
          <div 
            className="close-asoleacion-modal-mobile"
            onClick={() => {
              this.props.handleOpenAsoleacionModel()
            }}
          >
            <img src={pill} alt=""/>
          </div>
          <div className="asoleacion-name-container-mobile">
            <img src={asoleacion} alt=""/>
            <div>Asoleación</div>
          </div>

          <div className='asoleacion-input-mobile-container'>
            <div className="asoleacion-input-container-mobile">
              <input 
                type='range' 
                step={1} 
                min={0}
                max={this.props.asoleacionCurrentSetCount - 1} 
                onChange={(e: any) => {this.props.handleAsoleacionChangeIndex(e.target.value * 1)}}
                value={this.props.asoleacionCurrentSetIndex}
                ></input>
            </div>

            <div className="asoleacion-buttons-container-mobile">
              {
                this.props.asolacionData && this.props.asolacionData.times ?
                this.props.asolacionData.times.map((time: any, index: number) => 
                  <div 
                    className="asoleacion-times-btn-individual-mobile"
                    key={time.name + index}
                    style={{
                      right: time.bottom
                    }}
                    onClick={() => {this.props.handleChangeAsoleacionTime(time.frame)}}
                  >
                  <div className="asoleacion-times-image-container-mobile" onClick={() => {this.props.handleChangeAsoleacionTime(time.frame)}}>
                    <img src={time.icon} alt=""/>
                    </div>
                  </div>
                ):null
              }
              </div>
          </div>
            

            <div className="asoleacion-vistas-mobile-container">
              <div className="vistas-asoleacion-title-nobile">Vistas</div>
              {
                  this.props.asolacionData && this.props.asolacionData.vistas ?
                  this.props.asolacionData.vistas.map((vista: any, index: number) =>
                    <div 
                      key={vista.name + index}
                      className="asoleacion-vistas-btn-individual-mobile"
                      onClick={
                        index !== 3 ? 
                        () => {this.props.handleChangeAsoleacionSet(vista)}:
                        () => {this.props.handleAutoplayAsoleacion()}
                      }
                      style={{
                        backgroundColor: this.props.asoleacionCurrentSet.name === vista.name ? this.props.colorsData.main_buttons:'',
                        color: this.props.asoleacionCurrentSet.name === vista.name ? this.props.colorsData.secondary_text:'',
                        transition: "all 0.3s ease-in-out"
                      }}
                    >
                      {vista.name}
                    </div>
                    ):null
                  }
          </div>
        </div>
      )
  }
}

export default AsoleacionUI